import React, { useState } from 'react';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { fetcher } from '@dashboard/services/request';
import { apiKeysKey } from '@dashboard/lib/queryKeys';
import Button from '@dashboard/components/Button';
import Card from '@dashboard/components/Card';
import CardHeader from '@dashboard/components/CardHeader';
import CardHeaderTitle from '@dashboard/components/CardHeaderTitle';
import CardContent from '@dashboard/components/CardContent';
import SettingsDescription from '@dashboard/components/SettingsDescription';
import { PlusIcon } from '@heroicons/react/24/outline';
import ApiKeyTable from './components/ApiKeyTable';
import ApiKeyCreateDialog from './components/ApiKeyCreateDialog';
import Link from '@/dashboard/components/Link';

const SettingsApiKeys = () => {
  const [showCreateApiKeyDialog, setShowCreateApiKeyDialog] = useState(false);
  const { sellerId, token } = useAuth();

  const {
    data: apiKeys,
    isLoading: isLoadingApiKeys,
    isError: isErrorApiKeys,
  } = useQuery({
    queryKey: apiKeysKey(sellerId),
    queryFn: () => fetcher(`/sellers/${sellerId}/api-keys`, token),
    enabled: !!sellerId,
  });

  return (
    <Card variant="root">
      <CardHeader variant="root">
        <div className="flex items-start justify-between gap-x-4 w-full">
          <div className="flex flex-col max-w-lg">
            <CardHeaderTitle variant="root">API</CardHeaderTitle>
            <SettingsDescription className="mt-2">
              Use the API to integrate Checkout Page with your own apps and services.{' '}
              <Link target="_blank" to="/docs/api">
                View documentation
              </Link>
            </SettingsDescription>
          </div>
          <Button appearance="primary" onClick={() => setShowCreateApiKeyDialog(true)}>
            Create API key
            <PlusIcon className="w-4 h-4 ml-2 align-baseline" />
          </Button>
        </div>
      </CardHeader>

      <CardContent variant="root" className="mt-4 mb-32">
        <ApiKeyTable data={apiKeys} isLoading={isLoadingApiKeys} isError={isErrorApiKeys} />

        <ApiKeyCreateDialog
          open={showCreateApiKeyDialog}
          onClose={() => setShowCreateApiKeyDialog(false)}
        />
      </CardContent>
    </Card>
  );
};

export default SettingsApiKeys;
